/* eslint-disable no-unused-vars */
export enum Action {
  Details = 'details',
  ActionsHistory = 'actionsHistory',
  Deactive = 'deactive',
  Reactive = 'reactive',
  CorrectType = 'correctType',
  Exclude = 'exclude',
  ReportAnError = 'reportAnError',
  ChangeTopic = 'changeTopic',
  ChangeEntity = 'changeEntity',
  ChangeProceduralAct = 'changeProceduralAct',
  Unarchive = 'unarchive',
}
